import {
  Autocomplete,
  TextField,
  AutocompleteInputChangeReason,
  SxProps,
  Theme,
} from "@mui/material";
import { FC } from "react";

interface ISearchAutocompleteOptional {
  label: string;
  sx: SxProps<Theme>;
  keyLabel: string;
  keyValue: string;
  inputValue: string;
  onInputChange?: (
    event: React.SyntheticEvent,
    value: string,
    reason: AutocompleteInputChangeReason,
  ) => void;
  disabled: boolean;
  isLoading: boolean;
}

export type ChangeValue = Record<string, string>;
interface ISearchAutocomplete extends Partial<ISearchAutocompleteOptional> {
  options: any[];
  onChange: (
    event: React.SyntheticEvent,
    value: ChangeValue | null,
  ) => void | Promise<void>;
  value: Record<string, string> | null;
}

export const SearchAutocomplete: FC<ISearchAutocomplete> = ({
  keyLabel = "name",
  keyValue = "id",
  value,
  onChange,
  options,
  label,
  sx,
  onInputChange,
  inputValue,
  disabled,
  isLoading,
}) => {
  return (
    <Autocomplete
      disablePortal
      options={options}
      value={value}
      disabled={disabled}
      loading={isLoading}
      sx={{
        ...sx,
        "& .MuiInputBase-root": {
          top: "-6px",
          borderRadius: "0",
          height: "66px",
          fontFamily: "Montserrat, sans-serif",
        },
        "& .Mui-focused": {
          color: "#666666",
        },
      }}
      getOptionLabel={(option) => option[keyLabel] || ""}
      isOptionEqualToValue={(option, value) =>
        option[keyValue] === value?.[keyValue]
      }
      renderOption={(props, option) => (
        <li {...props} key={option[keyValue]}>
          {option[keyLabel]}
        </li>
      )}
      inputValue={inputValue}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          sx={{
            borderRadius: "0",
            "& .Mui-focused": {
              color: "#666666",
            },
          }}
        />
      )}
      onChange={(event, newValue) => {
        onChange(event, newValue);
      }}
      onInputChange={onInputChange}
    />
  );
};
